'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCafAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.72989e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -0.000175947 6.66667 2.72989e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M2.72989e-05 0H28V20H0L2.72989e-05 0Z", fill: "#19BFBF" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.0282 5.50254C8.0105 5.39635 8.04518 5.28816 8.1213 5.21204L10.569 2.7643C10.6315 2.70179 10.7163 2.66667 10.8047 2.66667H12.4607C12.5869 2.66667 12.7023 2.738 12.7588 2.85093L13.2412 3.81574C13.2977 3.92867 13.4131 4 13.5393 4H15.794C15.9202 4 16.0357 4.07133 16.0921 4.18426L17.9079 7.81574C17.9643 7.92867 18.0798 8 18.206 8H19.3333C19.608 8 19.7648 8.31359 19.6 8.53333L18.018 10.6426C18.006 10.6586 17.9955 10.6757 17.9866 10.6936L17.3685 11.9296C17.3454 11.9759 17.3333 12.0269 17.3333 12.0787V13.2546C17.3333 13.3064 17.3213 13.3574 17.2981 13.4037L15.4255 17.1491C15.369 17.262 15.2536 17.3333 15.1273 17.3333H14.206C14.0798 17.3333 13.9643 17.262 13.9079 17.1491L13.3685 16.0704C13.3454 16.0241 13.3333 15.9731 13.3333 15.9213V12.1381C13.3333 12.0497 13.2982 11.9649 13.2357 11.9024L12.7223 11.389C12.6857 11.3524 12.6581 11.3078 12.6418 11.2587L12.076 9.56126C12.0306 9.42514 11.9032 9.33333 11.7597 9.33333H8.94904C8.7861 9.33333 8.64703 9.21553 8.62024 9.0548L8.0282 5.50254Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.6667 13.6667C18.6667 13.4826 18.8159 13.3333 19 13.3333H19.6667C19.8508 13.3333 20 13.4826 20 13.6667V14.588C20 14.6397 19.988 14.6908 19.9648 14.737L19.4255 15.8157C19.369 15.9287 19.2536 16 19.1273 16H19C18.8159 16 18.6667 15.8508 18.6667 15.6667V13.6667Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagCafAsset = forwardRef(FlagCafAsset);

export { VpFlagCafAsset as default };
